var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#main-nav'),expression:"'#main-nav'"}],attrs:{"href":"#","id":"scrollToTop"}},[_c('i',{staticClass:"fas fa-arrow-up text-light"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }